import { Component, ChangeDetectorRef } from '@angular/core';
import { FieldArrayType, } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ECModalComponent } from './ec-modal/ec-modal.component';

@Component({
	selector: 'formly-repeat-ec-section',
	template: `
		<div
			class="repeat-section"
			[class.repeat-section-disabled]="props.disabled"
		>
			<!-- Header with label and add button -->
			<div class="repeat-section-header">
				<div class="section-header">
					<label class="section-title">{{ props.label }}</label>
				</div>

				<button
					*ngIf="!props.disabled"
					mat-icon-button
					color="primary"
					type="button"
					(click)="add()"
					[matTooltip]="props.addText || 'Add item'"
				>
					<mat-icon>add_circle_outline</mat-icon>
				</button>
			</div>

			<!-- List of items -->
			<div
				*ngFor="let field of field.fieldGroup; let i = index; let last = last"
				class="repeat-item"
				[class.repeat-item-last]="last"
				[class.repeat-item-deleted]="field.model?._delete"
			>
				<div class="repeat-item-content">
					<div class="repeat-item-index">{{ i + 1 }}</div>
					<div class="repeat-item-fields">
						<formly-field [field]="field"></formly-field>
					</div>
					<!-- Single button for sending ec complete -->
					<button
						*ngIf="field.model?._complete"
						mat-icon-button
						color="accent"
						type="button"
						(click)="toggleECComplete(field)"
						[disabled]="isECPending(field)"
						[matTooltip]="'Remove EC Complete'"
						class="repeat-item-button"
					>
						<mat-icon>check</mat-icon>
					</button>
					<button
						*ngIf="!field.model?._complete"
						mat-raised-button
						color="primary"
						type="button"
						(click)="toggleECComplete(field)"
						[matTooltip]="'Confirm EC Complete'"
						[disabled]="!field.model?.id || isECPending(field)"
						class="repeat-item-button"
					>
						Complete
					</button>
					<!-- Single toggle button for remove/restore -->
					<button
						*ngIf="!props.disabled"
						mat-icon-button
						[color]="field.model?._delete ? 'primary' : 'warn'"
						type="button"
						(click)="
								field.model?._delete ? restoreItem(field) : removeItem(field)
							"
						[matTooltip]="field.model?._delete ? 'Cancel remove' : 'Remove'"
						class="repeat-item-action"
					>
						<mat-icon>{{ field.model?._delete ? 'undo' : 'close' }}</mat-icon>
					</button>
				</div>
			</div>

			<!-- Empty state -->
			<div
				*ngIf="!field.fieldGroup || field.fieldGroup.length === 0"
				class="repeat-empty"
			>
				<mat-icon>inbox</mat-icon>
				<p>{{ props.emptyMessage || 'No items added yet' }}</p>
			</div>
		</div>
	`,
	styles: [
		`
			.repeat-section {
				border: 1px solid #e0e0e0;
				border-radius: 4px;
				background: #ffffff;
				margin-bottom: 24px;
			}

			.repeat-section-header {
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 12px 16px;
				border-bottom: 1px solid #e0e0e0;
				background: #fafafa;
			}

			.repeat-section-label {
				font-size: 14px;
				font-weight: 500;
				color: #35418d;
			}

			.repeat-item {
				border-bottom: 1px solid #e0e0e0;
			}

			.repeat-item-last {
				border-bottom: none;
			}

			/* Deleted item styling */
			.repeat-item-deleted {
				background-color: #ffebee;
			}

			.repeat-item-deleted .repeat-item-fields {
				text-decoration: line-through;
				color: #757575;
			}

			.repeat-item-deleted .repeat-item-index {
				background-color: #ef5350;
			}

			.repeat-item-content {
				display: flex;
				align-items: flex-start;
				gap: 4px;
				padding: 24px 12px 0 12px;
				transition: background-color 0.2s;
			}

			.repeat-section:not(.repeat-section-disabled) .repeat-item-content:hover {
				background-color: #f5f5f5;
			}

			.repeat-section:not(.repeat-section-disabled)
				.repeat-item-deleted
				.repeat-item-content:hover {
				background-color: #ffe0e3;
			}

			.repeat-item-index {
				display: flex;
				align-items: center;
				justify-content: center;
				min-width: 28px;
				height: 28px;
				margin-top: 6px;
				border-radius: 50%;
				background-color: #35418d;
				color: white;
				font-size: 13px;
				font-weight: 500;
				flex-shrink: 0;
			}

			.repeat-item-fields {
				flex: 1;
				min-width: 0;
			}

			/* Reduce left/right margins for row and columns */
			.repeat-item-fields ::ng-deep .row {
				margin-left: 0;
				margin-right: 0;
			}

			.repeat-item-fields ::ng-deep .col,
			.repeat-item-fields ::ng-deep [class*='col-'] {
				padding-left: 4px;
				padding-right: 4px;
			}

			.repeat-item-button {
				margin-top: 5px;
				width: 100px;
			}

			.repeat-item-button.mat-accent {
			    color: #388e3c;
				flex-shrink: 0;
				height: 36px;
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.repeat-item-action {
				flex-shrink: 0;
				width: 36px !important;
				height: 36px !important;
				margin-top: 5px;
				padding: 0 !important;
				display: flex !important;
				align-items: center !important;
				justify-content: center !important;
			}

			.repeat-item-action ::ng-deep .mat-mdc-button-persistent-ripple {
				border-radius: 50%;
			}

			.repeat-item-action ::ng-deep .mat-icon {
				font-size: 20px;
				width: 20px;
				height: 20px;
				line-height: 20px;
			}

			.repeat-item-action ::ng-deep .mat-mdc-button-touch-target {
				height: 36px;
				width: 36px;
			}

			.repeat-empty {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 32px 16px;
				color: #9e9e9e;
			}

			.repeat-empty mat-icon {
				font-size: 48px;
				width: 48px;
				height: 48px;
				margin-bottom: 8px;
				opacity: 0.5;
			}

			.repeat-empty p {
				font-size: 14px;
			}

			.mat-accent {
			    color: #388e3c;
			}

			.mat-mdc-raised-button>.mat-icon {
				margin-right: 0;
			}
		`,
	],
})
export class RepeatingECSectionType extends FieldArrayType {
	constructor(
		private readonly dialog: MatDialog,
		private cdr: ChangeDetectorRef,
	) {
		super();
	}

	private openECModal() {
		const dialogRef = this.dialog.open(ECModalComponent, {
			width: '500px',
		})
		return dialogRef;
	}

	/**
	 * Confirm EC Complete - Send an EC Complete note with EC details
	 */
	protected toggleECComplete(field: { model: { _complete: boolean } }): void {
		if (!this.field.fieldGroup) {
			return;
		}

		const dialogRef = this.openECModal();
		dialogRef.afterClosed().subscribe(isConfirm => {
			if (!isConfirm) {
				return;
			}
			const complete = !field.model._complete;
			const onToggleComplete: ((ec: any, complete: boolean) => Observable<boolean>) | undefined = this.props.onToggleComplete;
			if (!onToggleComplete) {
				field.model._complete = complete;
				this.cdr.detectChanges();
				return;
			}
			// Saved on its own, without the rest of the form; the status only changes if that save succeeds
			this.pendingECs.add(field.model);
			onToggleComplete(field.model, complete).subscribe({
				next: (saved) => {
					if (saved) {
						field.model._complete = complete;
					}
				},
				error: () => this.finishPendingEC(field.model),
				complete: () => this.finishPendingEC(field.model),
			});
		});
	}

	// Emergency contacts whose completed status is being saved
	private readonly pendingECs = new Set<object>();

	private finishPendingEC(model: object): void {
		this.pendingECs.delete(model);
		this.cdr.detectChanges(); // Manually trigger a UI refresh
	}

	protected isECPending(field: { model: object }): boolean {
		return this.pendingECs.has(field.model);
	}

	/**
	 * Remove an item - mark as deleted if it has an id, otherwise remove from array
	 */
	protected removeItem(field: any): void {
		if (!this.field.fieldGroup) {
			return;
		}

		const index = this.field.fieldGroup.indexOf(field);
		if (index === -1) {
			return;
		}

		// If the item has an id (existing record), mark it as deleted
		// Otherwise, remove it from the array (new item that was never saved)
		if (field.model?.id) {
			field.model._delete = true;
			// Mark the form control as dirty so the parent form knows there are changes
			field.formControl?.markAsDirty();
		} else {
			// New item without id - actually remove it from the array
			this.remove(index);
		}
	}

	/**
	 * Restore a deleted item by removing the _delete flag
	 */
	protected restoreItem(field: any): void {
		if (field.model?._delete) {
			delete field.model._delete;
			// Mark the form control as dirty so the parent form knows there are changes
			field.formControl?.markAsDirty();
		}
	}
}